<template>
  <v-card flat class="pt-2 pb-2 mx-auto overflow-y-auto overflow-x-hidden" :max-height="this.$halfHeight" min-width="350">
    <v-row dense>
      <v-col>
        <v-text-field
            v-model="this.search"
            :icon="this.$search_icon"
            variant="outlined"
            @input="this.searchCheck"
            @keyup.enter="this.getResults"
            label="Search Categories"
            density="compact"
            clearable
            @click:clear="getResults"
            class="ps-2 pe-2"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-list density="compact">
          <v-list-item href="/quotebuilder" class="bg-grey-lighten-4">All Categories</v-list-item>
          <v-list-item v-for="item in this.results" v-bind:key="item.id" :href="'/quotebuilder/?category_id=' + item.id">{{item.name}}</v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <loaderComponent :loader="this.loader" />
  </v-card>

  <!--loader/spinner-->
</template>

<script>
import loaderComponent from "@/components/loaderComponent.vue";
export default {
  name: "category_menuComponent.vue",
  components: {
    loaderComponent,
  },
  props: {
    id: null,
  },
  data(){
    return{
      pk_id: [],
      results: [],
      loader: false,
      search: '',
      treeKey: 0,
    }
  },
  watch: {
    pk_id: function(){
      this.$emit('changeValue', this.pk_id);
    },
    id: function (){
      this.pk_id = this.id;
    },
  },
  mounted() {
    this.getResults();
  },
  methods: {
    getResults(){
      this.loader = true;
      this.pk_id = this.id;
      this.axios.get(this.$csrf_url).then(
          this.axios.get(this.$main_api + "/categories/marketplace/list", {
            params: {
              'search': this.search,
            },
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
          })
              .then((response) => {
                this.results = response.data;
                this.loader = false;
                this.treeKey++;
              })
              .catch((error) => {
                this.snackbar = true;
                this.snackbar_message = error.response.data.message;
                this.snackbar_color = this.$alert_danger_color;
                this.snackbar_icon = this.$alert_danger_icon;
                this.loader = false;
              })
      );
    },
    searchCheck(){
      if(this.search.length >= 3){
        this.getResults();
      }
    },
  }
}
</script>

<style scoped>

</style>